module.exports = __webpack_public_path__ + "static/media/logo.431e1c15.png";